<template>
  <div class="content__positioning distancing text contact__us__content" style="width: inherit;">
  <div class="contact__us__inner">
    <span class="headlin-text">Contact Us</span>
    <div class="input-area" style="margin-top: 13%;">
      <div class="input-field-area">
        <div style="margin-bottom: 2%;">What is your name?</div>
        <input type="text" placeholder="eg. Jane Dow" class="input-filed" v-model="name">
      </div>
      <div class="input-field-area">
        <div style="margin-bottom: 2%;">What is your email?</div>
        <input type="text" placeholder="eg. myemail@myemail.com" class="input-filed" v-model="email">
      </div>
      <div class="input-field-area">
        <div style="margin-bottom: 2%;">Please type in your message below</div>
        <textarea id="text-area" name="message" cols="30" rows="10" v-model="message" style="width: 350px; height: 300px;"></textarea>
      </div>
      <vue-recaptcha :sitekey='config.googleRecaptcheSiteKey' :loadRecaptchaScript="true" v-if="!isDebug()">
        <button class="adway-btn-class" @click="makeRequest" style="position: relative;">
          <clip-loader :loading="contactUsRequest" :color="'#fff'"/>
          <div v-if="!contactUsRequest" class="btn__context">
            <span class="btn__text__bold_contact" >Send</span>
            <img style="position: absolute; top: 2px; width: 19px; margin-left: 5px;" src="./../../assets/right-arrow.png" alt="left arrow">
          </div>
        </button>
      </vue-recaptcha>
      <button class="adway-btn-class" @click="makeRequest" style="position: relative;" v-if="isDebug()">
        <clip-loader :loading="contactUsRequest" :color="'#fff'"/>
        <div v-if="!contactUsRequest" class="btn__context">
          <span class="btn__text__bold_contact">Send</span>
          <img style="position: absolute; top: 2px; width: 19px; margin-left: 5px;" src="./../../assets/right-arrow.png" alt="left arrow">
        </div>
      </button>
    </div>
  </div>
  </div>
</template>

<script>
import HTTPRequest from '../../plugins/utils/HttpRequest.js'
import Config from '../../plugins/utils/Config.js'
import toast from '@utils/toast.js'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
export default {
  name: 'ContactUs',
  data: function () {
    return {
      name: '',
      email: '',
      message: '',
      config: Config,
      contactUsRequest: false
    }
  },
  components: {
    ClipLoader
  },
  methods: {
    validateInputFileds () {
      if (this.name === '') {
        return false
      }
      if (this.email === '') {
        return false
      }
      if (this.message === '') {
        return false
      }
      if (!this.email.includes('@') || !this.email.includes('.') || this.email.includes('@.')) {
        return false
      }
      return true
    },
    makeRequest () {
      if (this.validateInputFileds()) {
        this.contactUsRequest = true
        var request = new HTTPRequest()
        var url = '/send/message'
        var body = {
          API_KEY: '',
          data: {
            name: this.name,
            email: this.email,
            message: this.message
          }
        }
        request.makeRequest('POST', url, body).then((response) => {
          this.contactUsRequest = false
          var jsonParse = JSON.parse(response)
          if (jsonParse.code === 0) {
            toast.successMessage('emiting messagesend')
            this.$emit('messagesend')
          } else {
            toast.errorMessage(jsonParse.message)
          }
        }).catch((error) => {
          toast.errorMessage(`Error ${error}`)
        })
      } else {
        this.contactUsRequest = false
        toast.errorMessage('Invalid input parameters')
      }
    }
  }
}
</script>

<style scoped>

.adway-btn-class span{
  font-size: 16px;
  font-weight: bold;
}

.adway-btn-class{
  width: 100% !important;
  height: auto !important;
  padding: 10px !important;
}

.btn__context{
  padding: 0px calc(50% - 32px) 0px calc(50% - 49px);
  position: relative;
}
.btn__text__bold_contact{
  padding-right: 5px;
  vertical-align: bottom;
  display: inline-block;
}

textarea{
  border: 1px solid #CCD4E0;
  border-radius: 5px;
  box-shadow: 0px 0px 6px rgba(81, 95, 152, 0.161);
  box-sizing: border-box;
}

</style>
